export default __webpack_public_path__ + "static/Compensation-748e4ebca956547d25e579fd483ff657.png";